module.exports = __webpack_public_path__ + "img/icon_vote_remove.26d7ce0c.png";